// CheckboxMessage.tsx
import React, { useState } from 'react';
import styles from "./Chatbot.module.scss";
import { Checkbox, Button } from '@mui/material';

type CheckboxMessageProps = {
    checkboxes: string[];
    rasa_slot_name: string;
    rasa_next_intent: string;
  handleSendSelected: (selectedCheckboxes: string[], rasa_slot_name: string, rasa_next_intent: string) => void;
};

const CheckboxMessage: React.FC<CheckboxMessageProps> = ({ checkboxes, rasa_slot_name, rasa_next_intent, handleSendSelected }) => {

  const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);

  const handleCheckboxChange = (payload: string, checked: boolean) => {
    setSelectedCheckboxes(prevSelected =>
      checked
        ? [...prevSelected, payload]
        : prevSelected.filter(item => item !== payload)
    );
  };

  const handleSendClick = () => {
    handleSendSelected(selectedCheckboxes, rasa_slot_name, rasa_next_intent);
  };

  return (
    <>
        <div>
            <Button onClick={handleSendClick} className={styles.sendButton}>
                Send selected options
            </Button>
        </div>
        <div className={styles.checkboxContainer}>
        {checkboxes.map((checkbox, index) => (
            <div key={index} className={styles.checkbox__container}>
            <Checkbox
                checked={selectedCheckboxes.includes(checkbox)}
                onChange={(e, checked) => handleCheckboxChange(checkbox, checked)}
                color="primary"
            />
            <span>{checkbox}</span>
            </div>
        ))}
        </div>
    </>
  );
};

export default CheckboxMessage;